module.exports = __webpack_public_path__ + "static/img/chain-node-num.ddfa9c4d.png";